import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  faUsers,
  faChartPie,
  faFileUpload,
  faUserCircle,
  faHome,
  faHeadset,
  faSignOutAlt,
  faLanguage,
  faWarehouseAlt,
  faAlignJustify,
  faBold,
  faSitemap,
  faBrowser,
  faRectangleHistoryCircleUser,
} from '@fortawesome/pro-duotone-svg-icons';
import IconGroup from './IconGroup';
import Control from './Control';
import { logout } from '../../../actions/auth';


export default function SidebarIcons() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    user: {
      first_name: firstName,
      last_name: lastName,
      npn,
      can_batch_upload: canBatch,
      can_view_shopper_data: canAgentRecords,
      can_view_users: canAdmin,
      can_view_reports: canReport,
      can_edit_translations: canTranslations,
      can_manage_agency: canManageAgencies,
      can_manage_campaigns: canManageCampaigns,
      can_view_calls: canViewCalls,
      can_manage_formulary: canManageFormulary,
      can_manage_logos: canManageLogos,
      can_manage_rts: canManageRTS,
      can_manage_leads: canManageLeads,
      report_access: reportAccess = [],
    },
    theme: {
      features: {
        analytics: analyticsFeature,
        agencies,
        campaigns,
        translations,
        agent_records: agentRecords,
        logos: logosFeature,
        sites: sitesFeature,
        batch: batchFeature,
        rts: rtsFeature,
        leadsManagement: leadsFeature,
        disruptionReport: disruptionReportFeature,
      },
      disruptionRID,
      disruptionAWS,
      disruptionLabel,
    },
  } = useSelector(store => store);

  function handleProfileClick() {
    dispatch({ type: 'CHANGE_TAB', tab: 'details' });
    navigate('/profile');
  }

  return (
    <div id="sidebar-icons" className="d-flex flex-column h-100 w-100">
      <Control />
      {canAdmin && (
        <IconGroup
          id="sb-profile"
          icon={faUserCircle}
          path="/profile"
          tooltip="Profile"
          onClick={() => handleProfileClick()}
        >
          <strong className="text-capitalize">
            {firstName}
            {' '}
            {lastName}
          </strong>
          {npn && (
            <>
              <br />
              <small className="align-top">
                #
                {npn}
              </small>
            </>
          )}
        </IconGroup>
      )}
      <IconGroup id="sb-path" icon={faHome} path="/main">
        Dashboard
      </IconGroup>
      {canAdmin && (
        <IconGroup id="sb-admin" icon={faUsers} path="/admin">
          User Admin
        </IconGroup>
      )}
      {canManageLeads && leadsFeature && (
        <IconGroup id="sb-leads" icon={faRectangleHistoryCircleUser} path="/leads">
          Leads Admin
        </IconGroup>
      )}
      {canReport && analyticsFeature && (
        <IconGroup id="sb-analytics" icon={faChartPie} path="/analytics">
          Analytics
        </IconGroup>
      )}
      {canAgentRecords && agentRecords && canViewCalls && (
        <IconGroup id="sb-records" icon={faHeadset} path="/records">
          Agent Records
        </IconGroup>
      )}
      {canAdmin && canBatch && batchFeature && (
        <IconGroup id="sb-batch" icon={faFileUpload} path="/batch">
          Batch Upload
        </IconGroup>
      )}
      {canAdmin && canTranslations && translations && (
        <IconGroup id="sb-translations" icon={faLanguage} path="/translations">
          Translations
        </IconGroup>
      )}
      {canAdmin && agencies && canManageAgencies && (
        <IconGroup id="sb-agencies" icon={faWarehouseAlt} path="/agencies">
          Agent Groups
        </IconGroup>
      )}
      {canAdmin && canManageCampaigns && campaigns && (
        <IconGroup id="sb-campaigns" icon={faAlignJustify} path="/campaigns">
          Campaigns
        </IconGroup>
      )}
      {canAdmin && canManageFormulary && sitesFeature && (
        <IconGroup id="sb-translations" icon={faBrowser} path="/sites">
          Site Management
        </IconGroup>
      )}
      {canAdmin && canManageLogos && logosFeature && (
        <IconGroup id="sb-logos" icon={faBold} path="/logos">
          Carrier Names & Display Names
        </IconGroup>
      )}
      {canAdmin && rtsFeature && canManageRTS && (
        <IconGroup id="sb-rts" icon={faSitemap} path="/rts">
          RTS
        </IconGroup>
      )}
      {(reportAccess || []).length && disruptionReportFeature && (
        <IconGroup
          id="sb-reports"
          icon={faChartPie}
          path={`/analytics/qs/?rid=${disruptionRID}&aws=${disruptionAWS}&statePerms=1`}
        >
          {disruptionLabel || 'Disruption Report'}
        </IconGroup>
      )}
      <IconGroup
        onClick={logout}
        id="sb-signout"
        icon={faSignOutAlt}
        path="/"
        className="mt-auto"
        flip="horizontal"
      >
        Sign Out
      </IconGroup>
    </div>
  );
}
